import { STATE } from 'app/constants';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import * as React from 'react';

import { startupTranslation } from './constants';
import { StartupState } from './types';

import { NewCaseBanner } from './components/new-case-banner';
import { OpenCaseBanner } from './components/open-case-banner';
import { scrollToTop } from 'app/infrastructure/platform/routing';
import { AppSetting } from 'app/infrastructure/hosting/app-settings';
import { authProvider } from 'dependencies/auth';

type StartupProps = StartupState & DefaultContainerProps;

export class StartupComponent extends React.Component<StartupProps> {
  public static statePath: string = STATE.startupAnonymousArea;

  public componentDidMount() {
    scrollToTop();
  }

  public render() {
    const { translation } = this.props;
    const isAnonymous = authProvider.isAnonymous;
    const hideAnonymousCasePassword =  isAnonymous && AppSetting.HideAnonymousCasePassword;

    return (
      <div key={1}>
        <NewCaseBanner
            textHeader={translation.new_case_header}
            textDescription={translation.new_case_description}
            textBtnRegisterNewCase={translation.new_case_register}
          />
        {!hideAnonymousCasePassword && <OpenCaseBanner
            textHeader={translation.open_case_header}
            textCaseNo={translation.open_case_case_no}
            textCasePassword={translation.open_case_case_password}
            textOpenCase={translation.open_case}
        />}
      </div>
    );
  }
}

const container = containerFactory(StartupComponent, undefined, null, startupTranslation);
export { container as Startup };
